<template>
    <div v-if="count"
         class="new-comment-notifications-counter"
         v-tippy
         :content="count > 1 ? count + ' new comments' : count + ' new comment'"
    >
        <span class="material-icons">chat_bubble</span>
        <span class="count">{{ count > 99 ? 99 : count }}</span>
    </div>
</template>

<script>
export default {
    props: {
        count: Number
    },
};
</script>

<style lang="scss" scoped>
.new-comment-notifications-counter {
    position: relative;
}

.material-icons {
    font-size: 18px;
    color: var(--primary);
}

.count {
    font-size: 0.7rem;
    line-height: 1;
    font-weight: bold;
    min-width: 18px;
    text-align: center;
    color: white;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -65%);
}
</style>
